import React, { useEffect, useRef, useState } from "react";
import "./Carousel.css";

import service1 from "../assets/service1.jpg";
import service2 from "../assets/service2.jpg";
import service3 from "../assets/service3.jpg";
import service4 from "../assets/service4.jpg";
import service5 from "../assets/service5.jpg";
import service6 from "../assets/service6.jpg";
import service7 from "../assets/service7.jpg";
import service8 from "../assets/service8.jpg";

const services = [
  { img: service1, title: "Social Media Marketing" },
  { img: service2, title: "SEO" },
  { img: service3, title: "Google/Social Media Ads" },
  { img: service4, title: "Email Marketing Campaign" },
  { img: service5, title: "Influencer Marketing" },
  { img: service6, title: "Web Development and Designers" },
  { img: service7, title: "Design & Branding" },
  { img: service8, title: "Video/Reels Content & Scripts" },
];

// 🔥 clone first 4 & last 4 for smooth infinite effect
const extended = [
  ...services.slice(-4),
  ...services,
  ...services.slice(0, 4),
];

export default function Carousel() {
  const [index, setIndex] = useState(4);
  const [transition, setTransition] = useState(true);
  const trackRef = useRef();
  const getSlidePercent = () => {
    return window.innerWidth <= 768 ? 50 : 25;
  };
  useEffect(() => {
  const interval = setInterval(() => {
    setIndex((prev) => prev + 1); // 🔥 safer than moveNext()
    setTransition(true);
  }, 2500);

  return () => clearInterval(interval);
}, [])

  const moveNext = () => {
    setIndex((prev) => prev + 1);
    setTransition(true);
  };

  const movePrev = () => {
    setIndex((prev) => prev - 1);
    setTransition(true);
  };

  const handleTransitionEnd = () => {
    // 🔥 reset without jump
    if (index >= services.length + 4) {
      setTransition(false);
      setIndex(4);
    }
    if (index <= 3) {
      setTransition(false);
      setIndex(services.length + 3);
    }
  };

  return (
    <div id="services"><h2 className="services-title">What We Offer</h2>
    <div className="carousel-container">
      <button className="arrow left" onClick={movePrev}>⇐</button>

      <div className="carousel-wrapper">
        <div
          className="carousel-track"
          ref={trackRef}
          style={{
            transform: `translateX(-${index * getSlidePercent()}%)`,
            transition: transition ? "transform 0.6s ease" : "none",
          }}
          onTransitionEnd={handleTransitionEnd}
        >
          {extended.map((item, i) => (
            <div className="card" key={i}>
              <img src={item.img} alt={item.title} />
              <p>{item.title}</p>
            </div>
          ))}
        </div>
      </div>

      <button className="arrow right" onClick={moveNext}>⇒</button>
    </div>
    </div>
  );
}